import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { versionStatus } from '@/constants.js';
import { useTrigger } from '@/utils/comHook.js';
import Add from '../modal/add/Add';
import RollBack from '../modal/roll_back/RollBack';
import ModalML from '@/components/modal_ml/ModalML';
import { useDispatch, useSelector } from 'dva';
import { useEffect, useCallback, useState } from 'react';
import { isEmptyObject } from '@/utils/comUtil';

const SearchGroup = (props) => {
  const { selectName, disabled, versionList, fetchData } = props || {};
  const [form] = Form.useForm();
  const bizData = useSelector((state) => state.dvm.approvalList);
  const [diagramNameOption, setDiagramNameOption] = useState({});
  const trigger = useTrigger();
  const trigger2 = useTrigger();
  const dispatch = useDispatch();
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    fetchData(values);
  };
  const getApprovalList = useCallback(() => {
    dispatch({
      type: 'dvm/getApprovalList',
    });
  }, [dispatch]);
  useEffect(() => {
    getApprovalList();
  }, [getApprovalList]);
  useEffect(() => {
    if (!bizData) {
      return;
    }
    let obj = {};
    bizData &&
      bizData.length > 0 &&
      bizData.map((item) => (obj[item.diagramName] = item.diagramName));
    setDiagramNameOption(obj);
  }, [bizData]);
  useEffect(() => {
    if (isEmptyObject(diagramNameOption)) {
      return;
    }
  }, [bizData, diagramNameOption]);

  const resetFiledVersion = () => {
    let fileValues = form.getFieldValue();
    fileValues.version = undefined;
    form.setFieldsValue({
      ...fileValues,
    });
  };

  const selectDecision = (val) => {
    resetFiledVersion();
    selectName(val);
  };

  const onReset = () => {
    form.resetFields();
  };
  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 版本号 */}
      <div className={styles.input_contain}>
        <SelectML
          height="37px"
          inputWidth="180px"
          labelwidth="130px"
          labelVal="决策图名称"
          placeVal="请选择决策图名称"
          name="diagramName"
          allowClear={true}
          option={toOption(diagramNameOption, true)}
          onChange={selectDecision}
        />
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="180px"
          labelVal="版本号"
          placeVal="请输入版本号"
          name="version"
          allowClear={true}
          option={versionList}
          disabled={disabled}
          // icon={}
        />

        {/* 版本状态 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="180px"
          labelVal="版本状态"
          placeVal="请选择版本状态"
          name="versionStatus"
          allowClear={true}
          option={toOption(versionStatus)}
          // icon={}
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML
          size="large"
          value="查询"
          htmlType="submit"
          // width="106px"
          // height="46px"
          fontsize="16px"
        />
        <ButtonML
          size="large"
          value="重置"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={onReset}
        />
        <ButtonML
          size="large"
          value="新增"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={trigger.open}
        />
        <ButtonML
          size="large"
          value="版本回滚"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={trigger2.open}
        />
      </div>
      <ModalML
        title="新增"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <Add handleOk={trigger.open} handleCancel={trigger.close} />
      </ModalML>
      <ModalML
        title="版本回滚"
        handleOk={trigger2.open}
        handleCancel={trigger2.close}
        visible={trigger2.visible}
      >
        <RollBack handleOk={trigger2.open} handleCancel={trigger2.close} />
      </ModalML>
    </Form>
  );
};

export default SearchGroup;
